<template>
  <v-app>
    <v-app-bar dense max-height="96">
      <img
        src="/static/logo2.png"
        style="max-width: 100px"
        class="mt-12 ml-8"
      />
      <v-spacer />
    </v-app-bar>
    <v-content>
      <v-container fluid fill-height>
        <v-row justify="center" align="center" v-if="loading">
          <div class="text-center">
            <div>
              <v-progress-circular
                class="my-4"
                :size="50"
                width="5"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <p class="display-1">{{ $t("Loading") }}...</p>
          </div>
        </v-row>
      </v-container>
    </v-content>
    <v-hover v-slot="{ hover }">
      <v-snackbar
        :elevation="hover ? 16 : 2"
        :timeout="hover ? -1 : 3000"
        top
        center
        :color="snackbar.color"
        v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn dark v-bind="attrs" @click.native="snackbar.show = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </v-hover>
  </v-app>
</template>

<script>
export default {
    data() {
        return {
            base64RedirectToken: '',
            loading: false,
            snackbar: {
                show: false,
                text: '',
                color: '',
            },
        };
    },
    mounted() {
        this.base64RedirectToken = this.$route.params.redirect_token;
        this.setTokenAndRedirect();
    },
    methods: {
        showErrorMessage(message) {
            this.snackbar.text = message;
            this.snackbar.show = true;
            this.snackbar.color = 'red';
        },
        setTokenAndRedirect() {
            try {
                this.loading = true;
                this.$store.dispatch('account/logout').then((resp) => {
                    var redirectData = JSON.parse(atob(this.base64RedirectToken));
                    var token = redirectData.access_token;
                    var redirectURL = redirectData.redirect_url;
                    this.$store.dispatch('account/setToken', token);
                    this.$router.push(redirectURL);
                    this.loading = false;
                });
            } catch (err) {
                this.showErrorMessage(err);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
